module.exports = __webpack_public_path__ + "assets/GoldMu2x.4d581478be9c379b588e4fcc8ba62ce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x-gold/GoldMu2x.png
// module id = 814
// module chunks = 0